<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto; height:auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Add to Emphasis
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Select Emphasis">
          <d-select v-model="form.emphasisId" placeholder="Select emphasis" required expanded>
            <option v-for="emphasis in emphases" :key="emphasis.id" :value="emphasis.id">
              {{ emphasis.name }}
            </option>
          </d-select>
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Save
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';
  export default {

    props: {
      userId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      emphases: [],
      saving: false,
      form: {
        emphasisId: 0,
      },
    }),

    mounted() {
      this.getEmphases();
    },

    methods: {
      async saveForm() {
        this.saving = true;

        try {
          await axios.post(`/api/users/${this.userId}/emphases/${this.form.emphasisId}`);
          this.$parent.events.getEmphasesPaged();
          this.$parent.close();
          this.$toast.success('Saved successfully!');
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },

      async getEmphases() {
        const { data } = await axios.get('/api/admin/system-config/emphases/paged?currentPage=1&pageSize=99999&sortDir=name asc');
        this.emphases = data.resultItems;
      },
    },

  };
</script>